export enum BorderRadius {
    None = 'none',
    Small = 'small',
    Standard = 'standard',
    Medium = 'medium',
    Large = 'large',
    XL = 'xl',
    XXL = '2xl',
    XXXL = '3xl',
    XXXXL = '4xl',
    Full = 'full'
}

export enum Spacing {
    None = 'none',
    XXXS = '3xs',
    XXS = '2xs',
    XS = 'xs',
    Small = 'small',
    Standard = 'standard',
    Medium = 'medium',
    Large = 'large',
    XL = 'xl',
    XXL = '2xl',
    XXXL = '3xl',
    XXXXL = '4xl',
    XXXXXL = '5xl'
}

export enum Shadow {
    None = 'none',
    Small = 'small',
    Standard = 'standard',
    Medium = 'medium',
    Large = 'large',
    XL = 'xl',
    XXL = '2xl',
    XXXL = '3xl',
    Inner = 'inner',
    Full = 'full'
}

export enum FlexDirection {
    Row = 'row',
    Column = 'column'
}

export type FlexDirectionLiteral = "row" | "column"

export enum Size {
    Full = '100',
    Half = '50',
    Third = '33',
    Quarter = '25',
    FitContent = 'fit-content',
}

export enum Align {
    Normal = 'normal',
    Stretch = 'stretch',
    Center = 'center',
    Start = 'start',
    End = 'end'
}

export enum Justify {
    Normal = 'normal',
    Stretch = 'stretch',
    Center = 'center',
    Start = 'start',
    End = 'end',
    SpaceBetween = 'space-between',
    SpaceAround = 'space-around',
    SpaceEvenly = 'space-evenly',
}

export enum AsidePosition {
    Default = 'before',
    Before = 'before',
    After = 'after'
}